import { useEffect, useMemo, useRef, useState } from 'react'
import { useAdvertising } from '@/context/AdvertisingContext.jsx'
import { DEFAULT_ADS_CONFIG, EDITORIAL_AUTO_AD_PAGES } from '@/config/adExperiments.js'
import MockAdSlot from './MockAdSlot.jsx'

// Auto Ads locations are chosen by Google. These boxes preview formats only.
export default function AutoAdsMock({ format }) {
  const policy = useAdvertising()
  const container = useRef(null)
  const [collapsed, setCollapsed] = useState(false)
  const [keyboard, setKeyboard] = useState(false)
  const auto = (policy.adConfig || DEFAULT_ADS_CONFIG).autoAds
  const anchor = format === 'anchor'
  const configured = auto.configurationVerified && auto.editorial && !auto.vignettes && (anchor ? auto.profile === 'anchors' && auto.anchors && !auto.inPage : auto.profile === 'in_page' && auto.inPage && !auto.anchors)
  const config = useMemo(() => ({ preferredMode: 'desktop', variants: {
    desktop: { width: 468, height: 60, configured, adUnitPath: '' },
    mobile: { width: 320, height: 50, configured, adUnitPath: '' },
    compact: { width: 300, height: 50, configured, adUnitPath: '' },
  } }), [configured])
  const enabled = policy.mockEnabled && EDITORIAL_AUTO_AD_PAGES.includes(policy.pageKey) && import.meta.env.VITE_ADS_MOCK_VARIANT !== 'control'
  useEffect(() => {
    if (!enabled || !anchor || !window.visualViewport) return undefined
    const viewport = window.visualViewport
    const originalHeight = viewport.height
    const resize = () => setKeyboard(viewport.height < originalHeight * 0.7)
    viewport.addEventListener('resize', resize)
    return () => viewport.removeEventListener('resize', resize)
  }, [enabled, anchor])
  if (!enabled || keyboard) return null
  return <aside className={anchor ? 'fixed inset-x-0 bottom-0 z-30 border-t border-amber-400/40 bg-slate-950/95 px-2 py-1' : 'my-8 border-y border-amber-400/30 py-4'} data-testid={anchor ? 'auto-anchor-mock' : 'auto-in-page-mock'} aria-label="Prévia de anúncio automático">
    <div className="mx-auto flex max-w-3xl items-center justify-center gap-2">
      <span className="text-center text-[10px] text-amber-100">Prévia Auto Ads{!anchor && ' · posição ilustrativa'}</span>
      {anchor && <button type="button" className="rounded px-2 text-xs text-amber-100" onClick={() => setCollapsed(value => !value)} aria-label={collapsed ? 'Expandir prévia de âncora' : 'Recolher prévia de âncora'}>{collapsed ? '↑' : '↓'}</button>}
    </div>
    {!collapsed && <div ref={container} className="w-full"><MockAdSlot placement={anchor ? 'autoAnchor' : 'autoInPage'} config={config} observeRef={container} position={anchor ? 'auto.anchor' : 'auto.in_page'} experiment={anchor ? 'auto_anchors' : 'auto_in_page'} experimentVariant="treatment" testId={anchor ? 'auto-anchor-preview' : 'auto-in-page-preview'} /></div>}
  </aside>
}
